import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPostPaymentMethod } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * 결제수단 등록 mutation.
 *
 * 성공 시 GET /payments/methods 캐시 무효화 — PaymentStep 캐러셀에 즉시 반영.
 */
export const usePostPaymentMethod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: apiPostPaymentMethod,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.PAYMENT_METHODS] })
    },
  })
}
